export default __webpack_public_path__ + "static/Deploy-and-Monitor-d83e5541778abf522ccc49c47c659a61.webp";